import ApiService from '@/helpers/api.service';
import moment from "moment";
import { Storage } from 'aws-amplify';
const API = new ApiService();

const PRP_ITEM_ENDPOINT = '/prp';

export const state = {
    prpRewards: [],
    prpRewardsPage: {
      totalRows: 0,
      totalPage: 0
    },
    errors: null
}

export const mutations = {
    // Reward
    UPDATE_PRP_REWARD_LIST(state, item){
      state.prpRewards = item;
    },
    UPDATE_PRP_REWARD_PAGE(state, pageInfo){
      state.prpRewardsPage = pageInfo;
    },
    SET_PROD_ERRORS(state, errors){
      state.errors = errors;
    }
}

export const actions = {

    // REWARDS
    listPrpReward(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${PRP_ITEM_ENDPOINT}/prp-reward`, params)
          .then(({ data }) => {
            if(data.status == "err"){
              reject();
            } else {
              context.commit('UPDATE_PRP_REWARD_LIST', data.message.rows);
              context.commit('UPDATE_PRP_REWARD_PAGE', {
                  totalRows: data.message.pageInfo.total,
                  totalPage: data.message.pageInfo.noOfPage
              });
              resolve();
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
    
    getPrpReward(context, peddlrTrackingId){
      return new Promise((resolve, reject) => {
        API.post(`${PRP_ITEM_ENDPOINT}/prp-reward-info`, {peddlrTrackingId: peddlrTrackingId})
          .then(({data}) => {
            if(data.status == "err"){
              reject(data.message);
            } else {
              resolve(data.message.rows);
            }
          })
          .catch(({response}) => {
            context.commit('SET_ESELLER_ERROR', response.data.errors);
          })
      });
    },
    createRecordPRP(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${PRP_ITEM_ENDPOINT}/create-record-prp`, params)
          .then(({data}) => {
            if(data.status == "err"){
              reject(data.message);
            } else {
              resolve(data);
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },


    // Logo upload
    uploadLogo(context, params){
      return new Promise((resolve, reject) => {
        var allowedType = ["jpg","jpeg","png","svg"];
        if(params.type && !allowedType.includes(params.type.toLowerCase())){
          reject("Filetype not allowed");
          return;
        }
  
        var metadata =  {
          customPrefix: {
            public: ''
          },
          expires: moment().add(365, 'days').toDate(),
        }
  
        if(params.type == 'svg'){
          metadata['contentType'] = 'image/svg+xml';
        }
        Storage.put(`${params.folder}/${params.filename}`, params.base64, metadata)
          .then(stored => {
              console.log(stored);

              resolve(stored.key.replace(params.folder + "/", ""));
          })
          .catch(err => {
              console.log(err);
              reject(err);
          });
      });
    },
    actionPRP(context, params) {
      return new Promise((resolve, reject) => {
        API.post(`${PRP_ITEM_ENDPOINT}/${params.action}`, params.body)
          .then(({ data }) => {
            if (data.status === "ok") {
              resolve(data)
            } else {
              reject(data.message)
            }
          })
          .catch(({ response }) => {
            context.commit('SET_ERROR', response.data.errors);
            reject();
          });
      });
    }
  }
  